export default __webpack_public_path__ + "static/media/couch-coder.d80772cc.png";